// extracted by mini-css-extract-plugin
export default {"post":"Post_post__aFAFG","post__title":"Post_post__title__VoqWD","post__date":"Post_post__date__mLHqO","compactPost":"Post_compactPost__c7bz+","readMore":"Post_readMore__GNMVx"};